import { StoryboardFunctionRegistryFactory } from "../../StoryboardFunctionRegistry.js";
export const {
  storyboardFunctions,
  registerStoryboardFunctions,
  checkPermissionsUsage
} = StoryboardFunctionRegistryFactory();
//# sourceMappingURL=StoryboardFunctions.js.map